module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/xthor2-389631e57cbe4c53569876792b64d242.jpg";